import styled from 'styled-components';

export const ListContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ListFallback = styled.div.attrs({})`
  display: flex;
  justify-content: center;
  padding: 32px 0;
`;

export const RenegotiationBlock = styled.div.attrs({})``;

export const RenegotiationHeader = styled.div.attrs({})`
  font-size: 15px;
  font-weight: 700;
  color: #1f1b2e;
`;

export const RenegotiationMeta = styled.div.attrs({})`
  margin-top: 2px;
  font-size: 12px;
  color: #718096;
`;

// Cobranca de renegociacao cujo log nao foi encontrado: nota neutra, nao erro.
export const UnavailableNote = styled.div.attrs({})`
  max-width: 520px;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 13px;
  text-align: center;
  color: #4a5568;
  background: rgba(123, 68, 242, 0.06);
`;
